import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "sessionSelect", "centerSelect"]

  connect() {
    this.allOptions = Array.from(this.sessionSelectTarget.options).map(opt => ({
      element: opt.cloneNode(true),
      type: opt.dataset.formationType || "",
      centerId: opt.dataset.centerId || ""
    }))
    // Le centre du commercial est présélectionné : la liste s'ouvre déjà sur ses sessions
    if (this.hasCenterSelectTarget && this.centerSelectTarget.value) this.filter()
  }

  filter() {
    const selectedType = this.typeSelectTarget.value
    const selectedCenter = this.hasCenterSelectTarget ? this.centerSelectTarget.value : ""
    const currentValue = this.sessionSelectTarget.value

    while (this.sessionSelectTarget.options.length > 0) {
      this.sessionSelectTarget.remove(0)
    }

    this.allOptions.forEach(({ element, type, centerId }) => {
      const typeOk = !selectedType || !type || type === selectedType
      const centerOk = !selectedCenter || !centerId || centerId === selectedCenter
      if (typeOk && centerOk) {
        this.sessionSelectTarget.appendChild(element.cloneNode(true))
      }
    })

    const stillExists = Array.from(this.sessionSelectTarget.options).some(o => o.value === currentValue)
    if (stillExists) {
      this.sessionSelectTarget.value = currentValue
    } else {
      this.sessionSelectTarget.value = ""
      this.sessionSelectTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
